import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ru';

const mixin = {
  components: {
    DatePicker,
  },
  data() {
    return {
      datepicker: {
        lang: {
          default: 'ru'
        },
        format: 'DD.MM.YYYY',
        valueType: 'YYYY-MM-DD',
      },
    }
  },methods:{
    dateTimeFormat(dt) {
      if (!dt || dt.trim().length<10)
        return '';
      const date = new Date(dt);
      const dateTimeFormat = new Intl.DateTimeFormat('ru', {
        year: 'numeric', month: '2-digit',
        day: '2-digit', hour: '2-digit', minute: '2-digit'
      });
      const [{value: day}, , {value: month}, , {value: year}, , {value: hour}, , {value: minute}] = dateTimeFormat.formatToParts(date);
      return day + "." + month + "." + year + " " + hour + ":" + minute;
    },
  }
}

export default mixin
